import React from "react";
import "./loader.css"; // <-- Make sure to create this file

export default function LoaderPage() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#000",
      }}
    >
      <div className="loader"></div>
    </div>
  );
}
